import { render, staticRenderFns } from "./BaseCertificates.vue?vue&type=template&id=2ae098b0&scoped=true&functional=true"
import script from "./BaseCertificates.vue?vue&type=script&lang=js"
export * from "./BaseCertificates.vue?vue&type=script&lang=js"
import style0 from "./BaseCertificates.vue?vue&type=style&index=0&id=2ae098b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "2ae098b0",
  null
  
)

export default component.exports